import UploadDropzone from './UploadDropzone';

export default UploadDropzone;
